function multiStepForm(element, args) {
    if (args === null || typeof args !== 'object' || $.isArray(args))
        throw " : Called with Invalid argument";

    var form = $(element);
    var tabs = form.find('.tab');
    var steps = form.find('.step');

    steps.each(function(i, e) {
        $(e).on('click', function(ev) {
            navigateTo(i);
        });
    });


    $('.mrk-prev-custom').click(function() {
        navigateTo(2);
        $('.mrk-next-btn .next').show();
        $('.mrk-prev-btn .previous').show();
        $('.mrk-prev-custom').hide();
        $('.mrk-next-custom').hide();
    });
    // $('[name="logo-type"]').change(function() {
    //     var index = Number($(this).attr('step'));
    //     navigateTo(index);
    //     $('.mrk-prev-btn .previous').hide();
    //     $('.mrk-next-btn .next').hide();
    //     $('.mrk-prev-custom').show();
    //     $('.mrk-next-custom').show();
    // });

    function navigateTo(i) {
        if(i == 2 && $('.mrk-step-2.current').length){
          if($('[name="mrk-main-logo-position"]:checked').length == 0 && $('[name="mrk-main-logo-position"]').length){
            return;
          }
          if (
              ($('[name="bundleItem-1-position"]').length && $('[name="bundleItem-1-position"]:checked').length === 0) ||
              ($('[name="bundleItem-2-position"]').length && $('[name="bundleItem-2-position"]:checked').length === 0) ||
              ($('[name="bundleItem-3-position"]').length && $('[name="bundleItem-3-position"]:checked').length === 0)
          ){
            return;
          }
        }
        if (i != 2) {
            $('.mrk-next-btn .next').show();
            $('.mrk-prev-btn .previous').show();
            $('.mrk-prev-custom').hide();
            $('.mrk-next-custom').hide();
        }
        if(i == 2){
            form.find('.next').addClass('goToLogoPage');
        }else{
            form.find('.next').removeClass('goToLogoPage');
        }
        tabs.removeClass('current').eq(i).addClass('current');

        if (!i > 0)
            form.find('.previous').addClass('disabled');
        else
            form.find('.previous').removeClass('disabled');

        var atTheEnd = i >= tabs.length - 1;
        var secondLast = i >= tabs.length - 2 || i >= tabs.length - 3;
        if (atTheEnd){
            form.find('.next').hide();
            form.find('.mrk-final-add-to-cart').show();
        }
        else
        {
            form.find('.next').show();
            form.find('.mrk-final-add-to-cart').hide();
        }
        if (atTheEnd || secondLast){
            $('.mrk-steps-footer').addClass('mrk-disable-btn');
            // form.find('.mrk-add-another-logo-wrapper').show();
            if($('[name="logo-type"]:checked').val() == 'Text Logo' && $('#logoText').val() != ''){
              $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            }else if($('[name="logo-type"]:checked').val() == 'Upload Your Logo' && $('.hiddenFileInput').val() != ''){
              $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            }
        }else{
            $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            // form.find('.mrk-add-another-logo-wrapper').hide();
        }
        form.find('.submit').toggle(atTheEnd);

        fixStepIndicator(curIndex());
        if(i == 3 || i==4){
          var index = Number($('[name="logo-type"]:checked').attr('step'));
          $('.mrk-prev-btn .previous').hide();
          $('.mrk-next-btn .next').hide();
          $('.mrk-prev-custom').show();
          $('.mrk-next-custom').show();
          if(index == i){
            return
          }
          navigateTo(index);
          
        }

        //Ak custom code
         if(i == 2){
            let assignmentStyleInputs = document.querySelector('input[name="same-logo"]:checked');
            if (assignmentStyleInputs.value == "no"){
            //   console.log('same selected')
            
              let remainingNumber;
              let allActivePositions = document.querySelectorAll(".selected-position.active").length;
              let allActiveDonePositions = document.querySelectorAll(".selected-position.active.done").length;
              remainingNumber = Number(allActivePositions - allActiveDonePositions);
              // remainingNumber = checkRemainingActivePositions();
              if (remainingNumber < 2) {
                // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block !important;");
              }
              else if (remainingNumber > 1) {
                document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: none;");
              }

              // console.log('remainingNumber',remainingNumber);
              if(remainingNumber < 1){
                // button.next-inner
                document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block;")
                document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.remove("disabled");
              }
              
            }
        }
        //Ak custom code
    }
    $('.goToLogoPage').click(function(e) {
        e.preventDefault();
        $('[name="logo-type"]').trigger('change');
    });
    function curIndex() {
        return tabs.index(tabs.filter('.current'));
    }

    function fixStepIndicator(n) {
        steps.each(function(i, e) {
            i == n ? $(e).addClass('active') : $(e).removeClass('active');
        });
    }

    form.find('.previous').click(function() {
        navigateTo(curIndex() - 1);
    });

    form.find('.next').click(function() {
        if ('validations' in args && typeof args.validations === 'object' && !$.isArray(args.validations)) {
            if (!('noValidate' in args) || (typeof args.noValidate === 'boolean' && !args.noValidate)) {
                form.validate(args.validations);
                if (form.valid() == true) {
                    navigateTo(curIndex() + 1);
                    return true;
                }
                return false;
            }
        }
        navigateTo(curIndex() + 1);
    });

    form.find('.submit').on('click', function(e) {
        if (typeof args.beforeSubmit !== 'undefined' && typeof args.beforeSubmit !== 'function')
            args.beforeSubmit(form, this);

        if (typeof args.submit === 'undefined' || (typeof args.submit === 'boolean' && args.submit)) {
            form.submit();
        }
    });

    if (typeof args.defaultStep === 'number') {
        navigateTo(args.defaultStep);
    }
    window.mrknavigateTo = navigateTo;
}